import { render, staticRenderFns } from "./PromotionLog.vue?vue&type=template&id=c04f1c76"
import script from "./PromotionLog.vue?vue&type=script&lang=js"
export * from "./PromotionLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports